(function (w, d) {
  'use strict';

  var marker = d.getElementById('es-deferred-features');
  if (!marker) return;

  var ES = w.ES || {};
  var config = {
    cardSwipe: marker.getAttribute('data-card-swipe-src') || '',
    specUnits: marker.getAttribute('data-spec-units-src') || '',
    specMode: marker.getAttribute('data-spec-units-mode') || '',
    swatchPreview: marker.getAttribute('data-swatch-preview-src') || '',
    pdpTabs: marker.getAttribute('data-pdp-tabs-src') || '',
    judgeMe: marker.getAttribute('data-judgeme-src') || '',
    designMode: marker.getAttribute('data-design-mode') === '1'
  };

  var fallbackRegistry = w.__ES_DEFERRED_FEATURES__ = w.__ES_DEFERRED_FEATURES__ || {};

  function report(feature, error) {
    if (ES.warn) {
      ES.warn('deferred-features', 'Feature failed: ' + feature, error, { feature: feature });
      return;
    }
    try {
      var detail = {
        source: 'es-deferred-features',
        feature: feature,
        message: error && error.message ? error.message : String(error || 'Unknown error')
      };
      d.dispatchEvent(new CustomEvent('es:runtime-error', { detail: detail }));
      if (config.designMode && w.console && console.warn) console.warn('[EYESHELLS deferred feature]', detail, error || '');
    } catch (_ignore) {}
  }

  function appendScript(feature, src, attr) {
    if (!src) return Promise.resolve(false);
    if (ES.loader && ES.loader.script) {
      return ES.loader.script('deferred:' + feature, src, {
        selector: 'script[' + attr + ']',
        attributes: (function () { var out = {}; out[attr] = '1'; return out; })()
      });
    }

    if (fallbackRegistry[feature] && fallbackRegistry[feature].promise) return fallbackRegistry[feature].promise;
    var existing = d.querySelector('script[' + attr + ']');
    if (existing) {
      var ready = existing.getAttribute('data-es-loaded') === '1';
      var existingPromise = ready ? Promise.resolve(true) : new Promise(function (resolve, reject) {
        existing.addEventListener('load', function () { resolve(true); }, { once: true });
        existing.addEventListener('error', function () { reject(new Error('Failed to load ' + feature)); }, { once: true });
      });
      fallbackRegistry[feature] = { promise: existingPromise, node: existing };
      return existingPromise;
    }

    var node = d.createElement('script');
    node.src = src;
    node.defer = true;
    node.setAttribute(attr, '1');
    var promise = new Promise(function (resolve, reject) {
      node.addEventListener('load', function () { node.setAttribute('data-es-loaded', '1'); resolve(true); }, { once: true });
      node.addEventListener('error', function () { reject(new Error('Failed to load ' + feature)); }, { once: true });
    }).catch(function (error) {
      report(feature, error);
      fallbackRegistry[feature] = null;
      return false;
    });
    fallbackRegistry[feature] = { promise: promise, node: node };
    (d.head || d.documentElement).appendChild(node);
    return promise;
  }

  function media(query) {
    if (ES.media && ES.media.query) return ES.media.query(query);
    try { return w.matchMedia ? w.matchMedia(query) : null; }
    catch (error) { report('matchMedia', error); return null; }
  }

  function loadOnMedia(feature, src, attr, query) {
    if (!src) return;
    var load = function () { appendScript(feature, src, attr); };
    if (ES.media && ES.media.onMatch) {
      ES.media.onMatch(query, load, { fallbackMatch: true });
      return;
    }
    var mq = media(query);
    if (!mq || mq.matches) load();
    if (!mq) return;
    var change = function (event) { if (event && event.matches) load(); };
    if (mq.addEventListener) mq.addEventListener('change', change);
    else if (mq.addListener) mq.addListener(change);
  }

  function closest(target, selector) {
    try { return target && target.closest ? target.closest(selector) : null; }
    catch (error) { report('closest', error); return null; }
  }

  loadOnMedia('cardSwipe', config.cardSwipe, 'data-es-card-swipe-asset', '(max-width: 989px)');

  if (config.specMode === 'immediate') {
    appendScript('specUnits', config.specUnits, 'data-es-spec-units-asset');
  } else if (config.specMode === 'quickview-intent' && config.specUnits) {
    var specMq = media('(min-width: 990px)');
    var maybeSpec = function (event) {
      if (specMq && !specMq.matches) return;
      if (closest(event && event.target, '.engoj_btn_quickview, .quickview, [data-id][class*="quickview"]')) {
        appendScript('specUnits', config.specUnits, 'data-es-spec-units-asset');
      }
    };
    d.addEventListener('mouseover', maybeSpec, { passive: true });
    d.addEventListener('focusin', maybeSpec, { passive: true });
    d.addEventListener('click', maybeSpec, true);
  }

  loadOnMedia('swatchPreview', config.swatchPreview, 'data-es-swatch-press-preview-asset', '(max-width: 767.98px)');
  loadOnMedia('pdpTabs', config.pdpTabs, 'data-es-pdp-tabs-swipe-asset', '(max-width: 991px) and (pointer: coarse)');

  if (config.judgeMe) {
    var judgeMeLoaded = false;
    var judgeMePromise = null;
    var stopJudgeMeObserver = function () {};
    var judgeMeModalSelector = [
      '.jdgm-modal',
      '.jdgm-write-rev-modal',
      '.jdgm-ask-question-form-wrapper',
      '.jdgm-rev__modal',
      '.jdgm-widget [role="dialog"]',
      '[class*="jdgm"][class*="modal"]',
      '[class*="jdgm"][role="dialog"]'
    ].join(',');
    var loadJudgeMe = function () {
      if (judgeMeLoaded) return Promise.resolve(true);
      if (judgeMePromise) return judgeMePromise;
      judgeMePromise = appendScript('judgeMe', config.judgeMe, 'data-es-judgeme-modal-close-asset').then(function (loaded) {
        if (!loaded) {
          judgeMePromise = null;
          return false;
        }
        judgeMeLoaded = true;
        stopJudgeMeObserver();
        return true;
      });
      return judgeMePromise;
    };
    var isJudgeMeNode = function (node) {
      return !!closest(node, '.jdgm-widget, .jdgm-review-widget, .jdgm-rev-widg, .jdgm-write-rev-link, [class*="jdgm"]');
    };
    ['click', 'focusin', 'pointerdown'].forEach(function (eventName) {
      d.addEventListener(eventName, function (event) { if (isJudgeMeNode(event.target)) loadJudgeMe(); }, eventName === 'click');
    });

    var mutationHandler = function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var nodes = mutations[i].addedNodes || [];
        for (var j = 0; j < nodes.length; j += 1) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          try {
            if ((node.matches && node.matches(judgeMeModalSelector)) ||
                (node.querySelector && node.querySelector(judgeMeModalSelector))) {
              loadJudgeMe();
              return;
            }
          } catch (error) { report('judgeMeObserver', error); }
        }
      }
    };

    if (ES.observe && ES.observe.dom) {
      stopJudgeMeObserver = ES.observe.dom(mutationHandler);
    } else if ('MutationObserver' in w) {
      var observer = new MutationObserver(mutationHandler);
      observer.observe(d.documentElement, { childList: true, subtree: true });
      stopJudgeMeObserver = function () { observer.disconnect(); };
    }
  }
})(window, document);
